import React from "react";
import Page from "../UI/Elements/Page";
import styled from "styled-components";

const Wrap = styled.div`
  .page__header h1 {
    text-align: center;
    margin-bottom: 1rem;
  }
  .card {
    background: #fff;
    border: 1px solid rgba(61, 30, 92, 0.06);
    border-radius: 24px;
    box-shadow: 0 18px 50px rgba(61, 30, 92, 0.08);
    padding: 2rem 2.25rem;
    max-width: 640px;
    margin: 0 auto;
    text-align: center;
  }
  .card p {
    font-family: 'Inter', sans-serif;
    color: var(--color-text-soft);
    margin: 0.5rem 0;
  }
  .card a {
    color: var(--color-coral);
    font-weight: 600;
    &:hover { color: var(--color-coral-deep); }
  }
`;

const Cancel = () => (
  <Wrap>
    <Page noBackground>
      <div className="page__header">
        <h1>Betaling mislukt</h1>
      </div>
      <div className="card">
        <p>Er is iets fout gelopen bij de betaling, gelieve opnieuw te proberen.</p>
        <p>Ga terug naar <a href="/checkout">betaling</a>.</p>
      </div>
    </Page>
  </Wrap>
);

export default Cancel;
